import { Suspense, StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store/store";
import reportWebVitals from "./reportWebVitals";
import "./languages/i18n";
import "primereact/resources/primereact.min.css";
import "/node_modules/primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "./styles/global.scss";
import RouterApp from "./router/RouterApp";
import { SpinnerPage } from "./components/SpinnerPage/SpinnerPage";
import { PrimeReactProvider } from "primereact/api";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <StrictMode>
    <PrimeReactProvider>
      <Provider store={store}>
        <Suspense fallback={<SpinnerPage />}>
          <RouterApp />
        </Suspense>
      </Provider>
    </PrimeReactProvider>
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
